import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'membershipChangePlan';
export const isMembershipPlanChangeLoadingSelector = isLoadingSelector(reducerName);
export const isMembershipPlanChangeUpdatedSelector = isUpdatedSelector(reducerName);
export const membershipPlanChangeErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selectors.js.map